import { Checkbox, Col, Form, Row } from "antd";
import React from "react";
import AdnCard from "../common/adnCard/AdnCard";
import AdnDatePicker from "../common/adnDatePicker/AdnDatePicker";
import AdnDropdown from "../common/adnDropdown/AdnDropdown";
import AdnEmail from "../common/adnEmail/AdnEmail";
import AdnFormOptions from "../common/adnFormOptions/AdnFormOptions";
import AdnInput from "../common/adnInput/AdnInput";
import AdnPageTitle from "../common/adnPageTitle/AdnPageTitle";
import AdnToolTip from "../common/adnToolTip/AdnToolTip";
import { AdnPhoneInput } from "../common/adnPhoneInput/AdnPhoneInput";
import {
  NameValidation,
  StatusOptions,
  dateFormat,
} from "../common/GeneralConfigurations";
import { AdnValidationAdentisEmail } from "../login/LoginValidations";
import { useTranslation } from "react-i18next";

export const UserForm = ({
  form,
  departments,
  positions,
  workPlaces,
  managers,
  roles,
  initValues,
  readOnly,
  disabledDate,
  defaultPickerValue,
  loading,
  submitLoading,
  title,
  handleCancel,
  handleFinish,
  handleBlurName,
  handleBlurEmail,
  isRH,
  userRole,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <AdnPageTitle title={title} />
      <AdnCard loading={loading}>
        <Form
          form={form}
          name="advanced_search"
          layout="vertical"
          className="ant-advanced-search-form"
          onFinish={handleFinish}
          initialValues={initValues}
        >
          <Row gutter={16}>
            <Col
              xs={{ span: 24 }}
              sm={{ span: 24 }}
              md={{ span: 24 }}
              lg={{ span: 24 }}
              xl={{ span: 6 }}
              xxl={{ span: 6 }}
              key={"name"}
              className="gutter-row"
            >
              <AdnInput
                label={t("user.form.labels.name")}
                name="name"
                placeholder={t("user.form.placeholders.insertName")}
                maxLength={50}
                readOnly={readOnly}
                rules={NameValidation}
                handleBlur={handleBlurName}
                disabled="true"
              />
            </Col>
            <Col
              xs={{ span: 24 }}
              sm={{ span: 24 }}
              md={{ span: 24 }}
              lg={{ span: 24 }}
              xl={{ span: 6 }}
              xxl={{ span: 6 }}
              key={"code-birthDate"}
              className="gutter-row"
            >
              <AdnInput
                label={t("user.form.labels.code")}
                name="code"
                placeholder={t("user.form.placeholders.insertCode")}
                maxLength={3}
                readOnly={readOnly}
                rules={[
                  {
                    required: true,
                    message: t("user.form.validation.codeRequired"),
                  },
                  {
                    pattern: /^[a-zA-Z]{3}$/,
                    message: t("user.form.validation.codePattern"),
                  },
                ]}
                disabled="true"
              />
            </Col>
            <Col
              xs={{ span: 24 }}
              sm={{ span: 24 }}
              md={{ span: 24 }}
              lg={{ span: 24 }}
              xl={{ span: 6 }}
              xxl={{ span: 6 }}
              key={"birthDate"}
              className="gutter-row"
            >
              <AdnDatePicker
                label={t("user.form.labels.birthDate")}
                name="birthDate"
                placeholder={t("user.form.placeholders.selectDate")}
                //disabledDate={disabledDate}
                defaultPickerValue={defaultPickerValue}
                disabled={readOnly}
                format={dateFormat}
              />
            </Col>
            <Col
              xs={{ span: 24 }}
              sm={{ span: 24 }}
              md={{ span: 24 }}
              lg={{ span: 24 }}
              xl={{ span: 6 }}
              xxl={{ span: 6 }}
              key={"positionId"}
              className="gutter-row"
            >
              {readOnly && !isRH ? (
                <AdnInput
                  label={t("user.form.labels.position")}
                  name="positionName"
                  readOnly={readOnly}
                />
              ) : (
                <AdnDropdown
                  placeholder={t("user.form.placeholders.selectPositions")}
                  options={positions}
                  name={"positionId"}
                  label={t("user.form.labels.position")}
                  rules={[
                    {
                      required: true,
                      message: t("user.form.validation.positionRequired"),
                    },
                  ]}
                />
              )}
            </Col>
          </Row>

          <Row gutter={16}>
            <Col
              xs={{ span: 24 }}
              sm={{ span: 24 }}
              md={{ span: 24 }}
              lg={{ span: 24 }}
              xl={{ span: 8 }}
              xxl={{ span: 8 }}
              key={"email"}
              className="gutter-row"
            >
              <AdnEmail
                readOnly={readOnly}
                placeholder={t("user.form.placeholders.insertEmail")}
                handleBlur={handleBlurEmail}
                validateType={AdnValidationAdentisEmail}
                disabled="true"
              />
            </Col>
            <Col
              xs={{ span: 24 }}
              sm={{ span: 24 }}
              md={{ span: 24 }}
              lg={{ span: 24 }}
              xl={{ span: 8 }}
              xxl={{ span: 8 }}
              key={"phone"}
              className="gutter-row"
            >
              <Row>
                <Col span={22}>
                  <AdnPhoneInput
                    name="phone"
                    rules={[
                      {
                        required: true,
                        message: t("user.form.validation.phoneRequired"),
                      },
                    ]}
                    disabled="true"
                  />
                </Col>
                <Col span={2}>
                  {initValues && initValues.invalidPhone && (
                    <AdnToolTip
                      title={t("user.form.tooltips.invalidNumber")}
                      color="red"
                    />
                  )}
                </Col>
              </Row>
            </Col>

            <Col
              xs={{ span: 24 }}
              sm={{ span: 24 }}
              md={{ span: 24 }}
              lg={{ span: 24 }}
              xl={{ span: 8 }}
              xxl={{ span: 8 }}
              key={"departmentId"}
              className="gutter-row"
            >
              {readOnly && !isRH ? (
                <AdnInput
                  label={t("user.form.labels.department")}
                  name="departmentName"
                  readOnly={readOnly}
                  disabled="true"
                />
              ) : (
                <AdnDropdown
                  placeholder={t("user.form.placeholders.selectDepartments")}
                  options={departments}
                  name={"departmentId"}
                  label={t("user.form.labels.department")}
                  rules={[
                    {
                      required: true,
                      message: t("user.form.validation.departmentRequired"),
                    },
                  ]}
                  disabled="true"
                />
              )}
            </Col>
          </Row>

          <Row gutter={16}>
            <Col
              xs={{ span: 24 }}
              sm={{ span: 24 }}
              md={{ span: 24 }}
              lg={{ span: 24 }}
              xl={{ span: 8 }}
              xxl={{ span: 8 }}
              key={"workPlace"}
              className="gutter-row"
            >
              {readOnly && !isRH ? (
                <AdnInput
                  label={t("user.form.labels.location")}
                  name={"workPlaceName"}
                  readOnly={readOnly}
                  disabled="true"
                />
              ) : (
                <AdnDropdown
                  options={workPlaces}
                  name={"workPlaceId"}
                  label={t("user.form.labels.location")}
                  rules={[
                    {
                      required: true,
                      message: t("user.form.validation.locationRequired"),
                    },
                  ]}
                  disabled="true"
                />
              )}
            </Col>
            {readOnly ? (
              initValues.seniorManagerId ? (
                <Col key={"seniorManager"} className="gutter-row">
                  <AdnInput
                    type={"name"}
                    label={t("user.form.labels.seniorManager")}
                    name={"seniorManagerName"}
                    readOnly={readOnly}
                    disabled="true"
                  />
                </Col>
              ) : (
                <></>
              )
            ) : (
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 24 }}
                lg={{ span: 24 }}
                xl={{ span: 8 }}
                xxl={{ span: 8 }}
              >
                <AdnDropdown
                  options={managers}
                  name={"seniorManagerId"}
                  label={t("user.form.labels.seniorManager")}
                  valueIsId={true}
                  allowClear={true}
                  disabled="true"
                />
              </Col>
            )}

            {title === t("user.pages.newUser") || (
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 24 }}
                lg={{ span: 24 }}
                xl={{ span: 8 }}
                xxl={{ span: 8 }}
                key={"status"}
                className="gutter-row"
              >
                {readOnly && !isRH ? (
                  <AdnInput
                    label={t("user.form.labels.status")}
                    name={"status"}
                    rules={[
                      {
                        required: true,
                        message: t("user.form.validation.phoneRequiredStatus"),
                      },
                    ]}
                    readOnly={readOnly}
                    disabled="true"
                  />
                ) : (
                  <AdnDropdown
                    options={StatusOptions}
                    name={"status"}
                    label={t("user.form.labels.status")}
                    disabled="true"
                  />
                )}
              </Col>
            )}
          </Row>
          <Row gutter={16}>
            <Col span={24} key={"rolesIds"}>
              <Form.Item
                name={"rolesIds"}
                label={t("user.form.labels.roles")}
                rules={
                  readOnly
                    ? []
                    : [
                        {
                          required: true,
                          message: t("user.form.validation.rolesRequired"),
                        },
                      ]
                }
              >
                {/*{(config.enable == "true") ? (*/}
                {/*    <label>{userRole?.join(", ") || "No roles assigned"}</label>*/}
                {/*) : (*/}
                <Checkbox.Group disabled={readOnly}>
                  {roles.map((role) => (
                    <Checkbox key={role.id} value={role.id}>
                      {role.name}
                    </Checkbox>
                  ))}
                </Checkbox.Group>
                {/*)}*/}
              </Form.Item>
            </Col>
          </Row>
          <AdnFormOptions
            handleCancel={handleCancel}
            readOnly={readOnly && !isRH}
            loading={submitLoading}
          />
        </Form>
      </AdnCard>
    </>
  );
};
